// Datepicker — кастомный календарь для CRM
// Event delegation — один раз на document
// Поддерживает single и range режимы

export function initDatepickers() {
	if (document._datepickerInit) return;
	document._datepickerInit = true;

	const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

	function fmtDate(date) {
		if (!date) return '';
		return String(date.getDate()).padStart(2, '0') + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
	}

	function fmtShort(date) {
		if (!date) return '';
		return String(date.getDate()).padStart(2, '0') + ' ' + monthNames[date.getMonth()];
	}

	function toDateString(date) {
		if (!date) return '';
		const d = String(date.getDate()).padStart(2, '0');
		const m = String(date.getMonth() + 1).padStart(2, '0');
		return d + '.' + m + '.' + date.getFullYear();
	}

	function parseDateAttr(str) {
		if (!str) return null;
		const [d, m, y] = str.split('.').map(Number);
		if (!d || !m || !y) return null;
		return new Date(y, m - 1, d);
	}

	function nightsBetween(d1, d2) {
		if (!d1 || !d2) return 0;
		return Math.round((d2 - d1) / (1000 * 60 * 60 * 24));
	}

	function ensureCalendar(picker) {
		let cal = picker.querySelector('.datepicker__calendar');
		if (cal) return cal;

		cal = document.createElement('div');
		cal.className = 'datepicker__calendar datepicker-calendar';
		cal.setAttribute('data-morph-skip', '');
		cal.innerHTML = buildCalendarHTML();
		picker.appendChild(cal);
		return cal;
	}

	function buildCalendarHTML() {
		const today = new Date();
		let html = '<div class="datepicker-calendar__main"><div class="datepicker-calendar__container">';
		html += '<div class="datepicker-calendar__header">';
		['Mo','Tu','We','Th','Fr','Sa','Su'].forEach(d => {
			html += '<div class="datepicker-calendar__header-cell">' + d + '</div>';
		});
		html += '</div><ul class="datepicker-calendar__month-list">';

		for (let i = 0; i < 6; i++) {
			const first = new Date(today.getFullYear(), today.getMonth() + i, 1);
			const year = first.getFullYear();
			const mon = first.getMonth();
			const title = first.toLocaleDateString('en', { month: 'long' }) + ' ' + year;
			const leadEmpty = (first.getDay() + 6) % 7;
			const daysInMonth = new Date(year, mon + 1, 0).getDate();

			html += '<li class="datepicker-calendar__month" data-year="' + year + '" data-month="' + mon + '">';
			html += '<div class="datepicker-calendar__month-title">' + title + '</div>';
			html += '<div class="datepicker-calendar__month-grid">';
			for (let e = 0; e < leadEmpty; e++) html += '<div class="datepicker-calendar__day-cell"></div>';
			for (let d = 1; d <= daysInMonth; d++) {
				html += '<div class="datepicker-calendar__day-cell"><button class="datepicker-calendar__day-btn" type="button" value="' + d + '">' + d + '</button></div>';
			}
			html += '</div></li>';
		}
		html += '</ul></div></div>';
		return html;
	}

	function dateFromBtn(btn) {
		const monthEl = btn.closest('.datepicker-calendar__month');
		return new Date(+monthEl.dataset.year, +monthEl.dataset.month, +btn.value);
	}

	function updateDisplay(picker) {
		const type = picker.dataset.datepickerType || 'single';
		const cal = picker.querySelector('.datepicker__calendar');
		const startDate = parseDateAttr(picker.dataset.datepickerDateStart);
		const endDate = type === 'range' ? parseDateAttr(picker.dataset.datepickerDateEnd) : null;

		// Start button
		const valStartEl = picker.querySelector('.datepicker__start-item .datepicker__main-item-value');
		const btnStart = picker.querySelector('.datepicker__start-item-btn');
		if (valStartEl) {
			valStartEl.textContent = startDate ? (type === 'range' ? fmtShort(startDate) : fmtDate(startDate)) : '';
		}
		if (btnStart) {
			btnStart.classList.toggle('ready', !!startDate);
		}

		// End button (range only)
		const valEndEl = picker.querySelector('.datepicker__end-item .datepicker__main-item-value');
		const btnEnd = picker.querySelector('.datepicker__end-item-btn');
		if (valEndEl) {
			valEndEl.textContent = endDate ? fmtShort(endDate) : '';
		}
		if (btnEnd) {
			btnEnd.classList.toggle('ready', !!endDate);
		}

		// Nights
		const nightsEl = picker.querySelector('.datepicker__main-nights');
		const nightsValueEl = picker.querySelector('.datepicker__main-nights-value');
		if (nightsEl && nightsValueEl) {
			const n = nightsBetween(startDate, endDate);
			if (n > 0) {
				nightsValueEl.textContent = n + ' night' + (n !== 1 ? 's' : '');
				nightsEl.classList.add('active');
			} else {
				nightsEl.classList.remove('active');
			}
		}

		// Hidden input value
		const valInput = picker.querySelector('.datepicker__value');
		if (valInput) {
			if (type === 'range') {
				valInput.value = toDateString(startDate) + (endDate ? ' - ' + toDateString(endDate) : '');
			} else {
				valInput.value = startDate ? toDateString(startDate) : '';
			}
		}

		// Day highlight
		if (cal) {
			cal.querySelectorAll('.datepicker-calendar__day-btn').forEach(btn => {
				btn.classList.remove('day-start', 'day-end', 'day-inside');
				const d = dateFromBtn(btn);
				if (startDate && d.getTime() === startDate.getTime()) btn.classList.add('day-start');
				if (endDate && d.getTime() === endDate.getTime()) btn.classList.add('day-end');
				if (startDate && endDate && d > startDate && d < endDate) btn.classList.add('day-inside');
			});
		}
	}

	// Клик по дню
	document.addEventListener('click', e => {
		const dayBtn = e.target.closest('.datepicker-calendar__day-btn');
		if (dayBtn) {
			const picker = dayBtn.closest('.datepicker');
			if (!picker) return;

			const type = picker.dataset.datepickerType || 'single';
			const date = dateFromBtn(dayBtn);

			if (type === 'single') {
				picker.dataset.datepickerDateStart = toDateString(date);
				updateDisplay(picker);

				const cal = picker.querySelector('.datepicker__calendar');
				if (cal) cal.classList.remove('active');

				const valInput = picker.querySelector('.datepicker__value');
				if (valInput) valInput.dispatchEvent(new Event('change', { bubbles: true }));
			} else {
				// Range mode
				const startDate = parseDateAttr(picker.dataset.datepickerDateStart);
				const endDate = parseDateAttr(picker.dataset.datepickerDateEnd);

				if (!startDate || (startDate && endDate)) {
					// Начинаем новый выбор
					picker.dataset.datepickerDateStart = toDateString(date);
					delete picker.dataset.datepickerDateEnd;
				} else {
					// Выбираем конец
					if (date < startDate) {
						picker.dataset.datepickerDateEnd = picker.dataset.datepickerDateStart;
						picker.dataset.datepickerDateStart = toDateString(date);
					} else {
						picker.dataset.datepickerDateEnd = toDateString(date);
					}

					// Обновляем display (записывает value в hidden input)
					updateDisplay(picker);

					// Закрываем после выбора обоих дат
					const cal = picker.querySelector('.datepicker__calendar');
					if (cal) cal.classList.remove('active');

					const valInput = picker.querySelector('.datepicker__value');
					if (valInput) valInput.dispatchEvent(new Event('change', { bubbles: true }));
				}
				updateDisplay(picker);
			}
			return;
		}

		// Клик по кнопке открытия (start или end)
		const toggleBtn = e.target.closest('.datepicker__start-item-btn') || e.target.closest('.datepicker__end-item-btn');
		if (toggleBtn) {
			const picker = toggleBtn.closest('.datepicker');
			if (!picker) return;

			// Закрываем другие
			document.querySelectorAll('.datepicker__calendar.active').forEach(cal => {
				if (!picker.contains(cal)) cal.classList.remove('active');
			});

			const cal = ensureCalendar(picker);
			cal.classList.toggle('active');
			updateDisplay(picker);
			return;
		}

		// Клик по кнопке сброса
		const resetBtn = e.target.closest('.datepicker__start-item-reset') || e.target.closest('.datepicker__end-item-reset');
		if (resetBtn) {
			const picker = resetBtn.closest('.datepicker');
			if (!picker) return;

			delete picker.dataset.datepickerDateStart;
			delete picker.dataset.datepickerDateEnd;
			updateDisplay(picker);

			const cal = picker.querySelector('.datepicker__calendar');
			if (cal) cal.classList.remove('active');

			const valInput = picker.querySelector('.datepicker__value');
			if (valInput) valInput.dispatchEvent(new Event('change', { bubbles: true }));
			return;
		}

		// Клик вне — закрытие
		if (!e.target.closest('.datepicker')) {
			document.querySelectorAll('.datepicker__calendar.active').forEach(cal => {
				cal.classList.remove('active');
			});
		}
	});
}
